// lib/recordDay.ts — C1: the Record home's own day-grouping formula
// ("Today · Yesterday · Fri 25 Sep"), factored out so RecordHome.tsx and
// its own test can both call it rather than the test re-deriving the same
// date arithmetic a second way.
export function dayLabel(iso: string, now: Date = new Date()): string {
  const d = new Date(iso);
  const startOf = (x: Date) => new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime();
  const diffDays = Math.round((startOf(now) - startOf(d)) / 86_400_000);
  if (diffDays === 0) return 'Today';
  if (diffDays === 1) return 'Yesterday';
  const weekday = d.toLocaleDateString('en-US', { weekday: 'short' });
  const day = d.getDate();
  const month = d.toLocaleDateString('en-US', { month: 'short' });
  return `${weekday} ${day} ${month}`;
}

/** Groups activity rows (already newest-first, as the tool answers them)
 *  into day buckets, preserving that order within and across groups —
 *  never re-sorted here. */
export function groupByDay<T extends { at: string }>(items: T[], now: Date = new Date()): Array<{ label: string; items: T[] }> {
  const groups: Array<{ label: string; items: T[] }> = [];
  for (const item of items) {
    const label = dayLabel(item.at, now);
    const last = groups[groups.length - 1];
    if (last && last.label === label) last.items.push(item);
    else groups.push({ label, items: [item] });
  }
  return groups;
}
